import { StyleSheet } from 'react-native';

import maxContainerWidthStyle from '../../../../styles/max-container-width/max-container-width.style';
import { mediaQueryValues } from '../../../media-query';
import {
  extraSmallPaddingVerticalBox,
  smallPaddingBottom,
  smallPaddingHorizontalBox,
} from '../../../view-style';

const mediaQuery = mediaQueryValues();

export default StyleSheet.create({
  keyboardContainer: {
    flex: 1,
  },
  container: {
    flexGrow: 1,
    flexShrink: 0,
    flexBasis: 'auto',
  },
  section: {
    flex: 1,
  },
  content: {
    marginTop: 25,
    ...maxContainerWidthStyle,
    ...smallPaddingBottom,
    paddingHorizontal: 15,
  },
  image: {
    marginBottom: -16,
    marginTop: mediaQuery.small,
  },
  card: {
    ...smallPaddingHorizontalBox,
    ...extraSmallPaddingVerticalBox,
  },
  audioPlayer: {
    paddingBottom: 0,
  },
  wordsContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    marginTop: 10,
    marginBottom: 30,
  },
  word: {
    marginHorizontal: 12,
    marginBottom: 10,
    flexDirection: 'row',
    alignItems: 'center',
  },
  wordText: {
    fontWeight: 'bold',
    fontSize: 24,
    marginLeft: 10,
  },
  hintButton: {
    marginTop: 20,
    marginBottom: 8,
  },
});
